<template>
  <div>
    <vue-dropzone
      ref="myVueDropzone"
      id="dropzone"
      duplicateCheck
      :options="dropzoneOptions"
      :destroyDropzone="false"
    ></vue-dropzone>
  </div>
</template>

<script>
import Vue from 'vue'
import Vuex from 'vuex'
import _ from 'lodash'
import vue2Dropzone from 'vue2-dropzone'
import { mapActions, mapGetters } from 'vuex'
import { validateEmail, validateText } from '@/services/Validate'

const csvFileType = [
  'text/csv',
  'text/plain',
  'application/csv',
  'text/comma-separated-values',
  'application/excel',
  'application/vnd.ms-excel',
  'application/vnd.msexcel',
  'text/anytext',
  'application/octet-stream',
  'application/txt',
]

export const DropzoneComponent = Vue.extend({
  // beforeUpdate() {
  //   console.log('before update')
  //   if (vue.defaultFiles) {
  //     _.forEach(vue.defaultFiles, async (attachment) => {
  //       this.$refs.myVueDropzone.manuallyAddFile(attachment, '')
  //     })
  //   }
  // },
  data() {
    return {
      cancel: Object,
      init: false,
    }
  },
  props: {
    uploadType: String,
    uploadToEngine: Function,
    uploadToStorage: Function,
    beforeUploadToStorage: Function,
    onRemove: Function,
    maxFiles: Number,
    afterUploadToStorage: Function,
    defaultFiles: Array,
    customOptins: Object,
    renameFile: Function,
  },
  components: {
    vueDropzone: vue2Dropzone,
  },
  computed: {
    dropzoneOptions() {
      const vue = this
      const defaultOption = {
        url: '/',
        method: 'PUT',
        uploadMultiple: true,
        addRemoveLinks: true,
        thumbnailMethod: 'contain',
        maxFiles: vue.maxFiles,
        dictDefaultMessage: 'Drag & drop file hear <div class="btn btn-upload-hear">Upload file <i class="v-icon mdi mdi-upload"></i></div>',
        dictFallbackMessage: 'Your browser does not support drag"n"drop file uploads.',
        renameFile: vue.renameFile,
        async accept(file, done) {
          console.log('vue.uploadType', vue.uploadType)
          const type = file.type
          console.log('type', type)
          if (vue.uploadType) {
            const types = _.split(vue.uploadType, ',')
            if (_.includes(vue.uploadType, 'csv') && _.includes(csvFileType, type)) {
              if (file.size <= 0) {
                this._errorProcessing([file], 'This file has no content inside.', {})
                return
              } else {
                file = await vue.uploadToEngine(file)
                done()
              }
            } else {
              const allowType = []
              const hexArray = {
                // csv: ['22494422', '706F6C69', '6E686E68', '6163636F', '54696D65'],
                pdf: ['25504446'],
                image: ['89504E47', '47494638', 'FFD8FFDB', 'FFD8FFE0', 'FFD8FFE1', 'FFD8FFEE'],
              }
              _.forEach(types, function(t) {
                const res = _.find(hexArray, function(e, index) {
                  return index === t
                })
                allowType.push(res)
              })
              const filereader = new FileReader()
              const blob = file.slice(0, 4)
              filereader.readAsArrayBuffer(blob)
              filereader.onloadend = async (evt) => {
                const uint = new Uint8Array(evt.target.result)
                const bytes = []
                uint.forEach( (byte) => {
                  bytes.push(byte.toString(16))
                })
                const hex = bytes.join('').toUpperCase()
                // console.log('hex ', hex)
                const pass = _.flattenDeep(allowType).includes(hex)
                if (!pass) {
                  this._errorProcessing([file], 'File format not supported.', {})
                  return
                } else {
                  file = await vue.uploadToEngine(file)
                  done()
                }
              }
            }
          } else {
            file = await vue.uploadToEngine(file)
            done()
          }
        },
        init() {
          const selfInit = this
          // console.log('default', vue.defaultFiles)
          if (vue.defaultFiles) {
            _.forEach(vue.defaultFiles, async (attachment) => {
              // selfInit.files.push(attachment)
              selfInit.emit('addedfile', attachment)
              // if (attachment.thumbnail) {
              //   console.log(attachment.thumbnail)
              //   selfInit.emit('thumbnail', attachment, attachment.thumbnail)
              // }
              if (attachment.error) {
                selfInit._errorProcessing([attachment], attachment.error, {})
              }
              selfInit.emit('complete', attachment)
            })
          }
          this.on('sending', function(file, xhr, formData) {

            const selfSending = this

            if (vue.beforeUploadToStorage) {
              file = vue.beforeUploadToStorage(file, vue, xhr, selfSending)
            }

            if (vue.uploadToStorage) {
              file = vue.uploadToStorage(file, vue, xhr, selfSending)
            }

            if (vue.afterUploadToStorage) {
              file = vue.afterUploadToStorage(file, vue, xhr, selfSending)
            }
          })

          this.on('canceled', function(file) {
            vue.cancel[file.upload.uuid]()
          })

          this.on('removedfile', function(file, error) {
            if (vue.onRemove) {
              vue.onRemove(file)
            }
          })

        },
      }
      const options = _.assign(defaultOption, this.customOptins)
      this.init = true
      return options
    },
  },
})
export default DropzoneComponent
</script>